export const baseUrl="http://13.50.10.46/api/v1/admin"

// export const baseUrl = "http://localhost:9731/api/v1/admin";
